// src/pages/PaymentCancelled.tsx
import React, {useEffect, useState } from 'react';
import {useLocation, useNavigate } from 'react-router-dom';
import {doc, getDoc } from 'firebase/firestore';
import {db } from '../../firebase';
import {MessageContainer } from '../registeredUsers/styles/BuyStall.styles';
import {Button } from '../registeredUsers/styles/BuyStall.styles';

const PaymentCancelled: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [stallNumber, setStallNumber] = useState('');
  const [businessName, setBusinessName] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStallDetails = async () => {
      const queryParams = new URLSearchParams(location.search);
      const orderMerchantReference = queryParams.get('OrderMerchantReference');

      if (orderMerchantReference) {
        try {
          const stallDocRef = doc(db, 'stalls', orderMerchantReference);
          const stallDoc = await getDoc(stallDocRef);
          
          if (stallDoc.exists()) {
            setStallNumber(stallDoc.data().stallNumber);
            setBusinessName(stallDoc.data().businessName);
          }
        } catch (error) {
          console.error('Error fetching stall details:', error);
        }
      }
      setLoading(false);
    };

    fetchStallDetails();
  }, [location]);

  return (
    <div style={{
      padding: '2rem', 
      maxWidth: '800px', 
      margin: '0 auto',
      textAlign: 'center'
    }}>
      <h2>Payment Cancelled</h2>
      
      {loading ? (
        <p>Loading...</p>
      ) : (
        <>
          <MessageContainer type="warning">
            You cancelled the payment process. Your stall has not been activated.
            
            {stallNumber && (
              <div style={{marginTop: '1rem' }}>
                <p><strong>Stall Number:</strong> {stallNumber}</p>
                {businessName && <p><strong>Business Name:</strong> {businessName}</p>}
              </div>
            )}
          </MessageContainer>

          <div style={{marginTop: '2rem' }}>
            <Button onClick={() => navigate('/buy-stall')}>
              Complete Payment Now
            </Button>
            <Button 
              onClick={() => navigate('/user-listings')}
              style={{marginLeft: '1rem', backgroundColor: '#f0f0f0', color: '#333' }}
            >
              View My Listings
            </Button>
          </div>

          <div style={{marginTop: '1rem', fontSize: '0.9rem', color: '#666' }}>
            <p>Need help? Contact our support team for assistance.</p>
          </div>
        </>
      )}
    </div>
  );
};

export default PaymentCancelled;